import { Image } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'

import { getExternalIdCustomName } from 'Modules/order/utils/order.utils'

import { CardBody, Heading } from 'Components/_theme'

import { E2E_ERROR } from 'Constants/e2e'

import errorPageImage from 'Assets/images/errorpage/refresh_the_page.svg'

import { useStore } from 'Portal/src/stores'

import type { ModalErrorStateProps } from './ModalErrorState.types'

export const ModalErrorState = (props: ModalErrorStateProps) => {
  const { error } = props

  const { organisationStore } = useStore()
  const { organisationConfigList } = organisationStore

  const intl = useIntl()

  const externalIdCustomName = getExternalIdCustomName(
    organisationConfigList,
    intl,
  )

  const isExternalIdErrorDetected = error?.message.includes(
    'external_case_id_per_org',
  )

  return (
    <CardBody>
      <div className="ModalErrorState" data-e2e={E2E_ERROR}>
        <Image
          alt={intl.formatMessage({
            id: 'Img_alt_page_error',
          })}
          src={errorPageImage}
        />

        <div className="text-center">
          <Heading as={4} size={2}>
            <FormattedMessage id="Error_occurred" />
          </Heading>
        </div>

        {isExternalIdErrorDetected ? (
          <FormattedMessage
            id="NewOrderSummary_external_id_error"
            values={{ customName: externalIdCustomName }}
          />
        ) : (
          error && <span className="mt-4">{error.message}</span>
        )}
      </div>
    </CardBody>
  )
}
